{
  "common": {
    "save": "Salvar",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "edit": "Editar",
    "create": "Criar",
    "loading": "Carregando...",
    "saving": "Salvando...",
    "search": "Buscar",
    "confirm": "Confirmar"
  },
  "sidebar": {
    "dashboard": "Painel",
    "users": "Usuários",
    "brands": "Lojas",
    "categories": "Categorias",
    "institutions": "Instituições",
    "transactions": "Transações",
    "donations": "Doações",
    "coupons": "Cupons",
    "sync": "Sincronização",
    "integrations": "Integrações",
    "blog": "Blog",
    "marketing": "Marketing",
    "international": "Internacional",
    "localization": "Localização"
  },
  "toasts": {
    "saved": "Alterações salvas com sucesso.",
    "error": "Ocorreu um erro. Tente novamente."
  },
  "localization": {
    "title": "Localização",
    "description": "Defina o idioma do site público e o seu idioma do painel.",
    "publicSiteLanguage": "Idioma do site (público global)",
    "publicSiteLanguageHelp": "Idioma exibido para visitantes. Afeta todo o site público.",
    "dashboardLanguage": "Idioma do meu painel",
    "dashboardLanguageHelp": "Apenas para sua conta. Não afeta o site público nem outros administradores.",
    "savePublic": "Salvar idioma público",
    "saveDashboard": "Salvar meu idioma",
    "publicSaved": "Idioma público atualizado.",
    "dashboardSaved": "Seu idioma do painel foi atualizado."
  }
}